import {
    IS_SUBSCRIBE_INFO_LOADING,
    SUBSCRIBE_INFO_FETCH_DATA_SUCCESS,
    SUBSCRIBE_INFO_HAS_ERROR,
    IS_UPDATED_TEAM_NAME_LOADING,
    UPDATED_TEAM_NAME_FETCH_DATA_SUCCESS,
    UPDATED_TEAM_NAME_HAS_ERROR,    
    IS_DELETE_FANTASY_TEAM_LOADING,
    DELETE_FANTASY_TEAM_FETCH_DATA_SUCCESS,
    DELETE_FANTASY_TEAM_HAS_ERROR,
} from './../constants/action-types';
// import config from './../config';
import common from './../common';
import {
    getSubscribeInfoAPI,
    postUpdateTeamNameAPI,
    deleteFantasyTeamAPI,
} from "../constants/api-url";

// get Subscribe Info
export function getSubscribeInfo() {
    const guid = common.getGUID();
    let getSubscribeInfo = getSubscribeInfoAPI.replace('{GUID}', guid);
    const params = { optType: 1 };
    return (dispatch) => common.makeAPICall(getSubscribeInfo, dispatch, isSubscribeInfoLoading, subscribeInfoFetchDataSuccess, subscribeInfoHasError, params);
}

export function isSubscribeInfoLoading(bool) {
    return {
        type   : IS_SUBSCRIBE_INFO_LOADING,
        payload: bool
    };
}

export function subscribeInfoHasError(bool) {
    return {
        type   : SUBSCRIBE_INFO_HAS_ERROR,
        payload: bool
    };
}

export function subscribeInfoFetchDataSuccess(subscribeInfo) {
    return {
        type   : SUBSCRIBE_INFO_FETCH_DATA_SUCCESS,
        payload: subscribeInfo
    };
}

// Update Team Name api
export function postUpdateTeamName(obj) {
    const data = obj;
    let postUpdateTeamName = postUpdateTeamNameAPI;
    return (dispatch) => common.makeAPICall(postUpdateTeamName, dispatch, isUpdatedTeamNameLoading, updatedTeamNameSuccess, updatedTeamNameHasError, data, 'POST');
}

export function isUpdatedTeamNameLoading(bool) {
    return {
        type   : IS_UPDATED_TEAM_NAME_LOADING,
        payload: bool
    };
}

export function updatedTeamNameHasError(bool) {
    return {
        type   : UPDATED_TEAM_NAME_HAS_ERROR,
        payload: bool
    };
}

export function updatedTeamNameSuccess(response) {
    return {
        type   : UPDATED_TEAM_NAME_FETCH_DATA_SUCCESS,
        payload: response
    };
}

// Delete fantasy team api
export function postDeleteFantasyTeam(obj) {
    const data = obj;
    let deleteFantasyTeam = deleteFantasyTeamAPI;
    return (dispatch) => common.makeAPICall(deleteFantasyTeam, dispatch, isDeleteFantasyTeamLoading, deleteFantasyTeamSuccess, deleteFantasyTeamHasError, data, 'POST');
}

export function isDeleteFantasyTeamLoading(bool) {
    return {
        type   : IS_DELETE_FANTASY_TEAM_LOADING,
        payload: bool
    };
}

export function deleteFantasyTeamHasError(bool) {
    return {
        type   : DELETE_FANTASY_TEAM_HAS_ERROR,
        payload: bool
    };
}

export function deleteFantasyTeamSuccess(response) {
    return {
        type   : DELETE_FANTASY_TEAM_FETCH_DATA_SUCCESS,
        payload: response
    };
}


// WEBPACK FOOTER //
// ./src/actions/SettingActions.js